// Whether the global loading overlay (CustomLoading) covers the current navigation.
// Decided by the 00.route-cover global middleware, which knows `to` and `from`; cleared by
// CustomLoading when the navigation ends. AB#64327
export const useRouteCover = () => useState<boolean>('route-cover', () => false)
